import type { ClientItemId } from 'owa-client-ids';
import type { ItemRow } from 'owa-graph-schema';
import type { TableView } from 'owa-mail-list-store';
import type Message from 'owa-service/lib/contract/Message';
import { TableQueryType } from 'owa-mail-list-store';
import type TableViewItemRelation from 'owa-mail-list-store/lib/store/schema/TableViewItemRelation';
import { getMailboxInfo } from 'owa-mail-mailboxinfo';
import { lazyGetItemClientIdForSearchResult } from 'owa-mail-search/lib/lazyFunctions';

export function getItemClientId(item: ItemRow | Message, tableView: TableView): ClientItemId {
    if (tableView?.tableQuery?.type == TableQueryType.Search) {
        const getItemClientIdForSearchResult = lazyGetItemClientIdForSearchResult.tryImportForRender();
        if (getItemClientIdForSearchResult) {
            return getItemClientIdForSearchResult(item as ItemRow, tableView);
        }
    }

    return {
        Id: item.ItemId!.Id,
        mailboxInfo: getMailboxInfo(tableView),
    };
}

export default function mapItemTypeToItemRelation(
    item: ItemRow,
    tableView: TableView
): TableViewItemRelation {
    return <TableViewItemRelation>{
        executeSearchSortOrder: item.SortOrderSource,
        clientId: getItemClientId(item, tableView),
        instanceKey: item.InstanceKey,
    };
}
